import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MaterialModule } from "../../material/material.module";
import { FormsModule } from "@angular/forms";
import { CurveRangeComponent } from "./curve-range.component";

const COMPONENTS = [
    CurveRangeComponent
];

@NgModule({
    declarations: COMPONENTS,
    imports: [
        CommonModule,
        FormsModule
    ],
    exports: COMPONENTS
})

export class CurveRangeModule { }

